/* eslint-disable no-nested-ternary */
import { FC, useState } from 'react'
import { Table, Toolbar, BreadcrumHeader } from 'shared'
import { useTableHandlers } from 'hooks/useTableHandlers'
import { BreadcrumbItemType } from 'shared/molecules/Breadcrum/Breadcrum'
import { DateTimeCell, StatusCell } from 'shared/molecules/table/cells'
import ConfidenceScoreCell from 'shared/molecules/table/cells/ConfidenceScoreCell'
import { IFilter, Operator } from 'api/types'
import { DOCUMENT_TYPES, thresholds, ThresholdsListRequest } from '../types'
import { useGetThresholdsQuery } from '../ThresholdsApiSlice'
import CreateThresholds from '../Createthreshold/CreateThreshold'
import './thresholds.scss'

const { Column, HeaderCell, Cell, ActionCell } = Table

const ThresholdsList: FC = () => {
  const [addThresholdsModal, setAddThresholdsModal] = useState(false)
  const [isEditMode, setIsEditMode] = useState<boolean>(false)
  const [selectRowThresholds, setSelectRowThresholds] =
    useState<thresholds | null>(null)
  const { requestBody, onPageChange, onFilterChange } = useTableHandlers<
    thresholds,
    ThresholdsListRequest
  >({
    page: { size: 10, number: 0 },
    filters: []
  })
  const { data: ThresholdsData, isLoading } = useGetThresholdsQuery(requestBody)

  const handleTabChange = () => {}

  const handleActionEdit = (rowData: thresholds) => {
    setAddThresholdsModal(true)
    setSelectRowThresholds(rowData)
  }

  const handleAction = (eventKey: string | undefined, rowData: thresholds) => {
    switch (eventKey) {
      case '2':
        setIsEditMode(true)
        handleActionEdit(rowData)
        break
      default:
        break
    }
  }
  const COLUMNS = [
    { key: 'fieldKey', label: 'FiledName' },
    { key: 'minConfidenceScore', label: 'Confidence Score' },
    { key: 'documentType', label: 'Document Type' },
    { key: 'isActive', label: 'Active' }
  ]

  const dropdownOptions = [
    { label: 'Payment Remittance', value: DOCUMENT_TYPES.PAYMENT_REMITTANCE },
    {
      label: 'Payment Remittance Line Item',
      value: DOCUMENT_TYPES.PAYMENT_REMITTANCE_LINE_ITEM
    },
    { label: 'Invoice', value: DOCUMENT_TYPES.INVOICE }
  ]

  const options = [
    {
      label: 'All',
      value: 'All',
      onClick: () => handleTabChange()
    }
  ]

  const total = ThresholdsData?.totalElements ?? 0
  const breadcrumbItems: BreadcrumbItemType[] = [
    {
      label: 'Setting',
      path: '/client',
      isActive: true
    },
    {
      label: 'Thresholds',
      path: '/thresholds',
      isActive: true
    }
  ]
  const handleClose = () => {
    setAddThresholdsModal(false)
    setSelectRowThresholds(null)
    setIsEditMode(false)
  }

  const handleDropdown = (value: string) => {
    const documentFilter: IFilter<thresholds> = {
      fieldName: 'documentType',
      operator: Operator.EQ,
      fieldValue: value ?? ''
    }

    const updatedFilters = [
      documentFilter,
      ...(requestBody.filters ?? []).filter(
        (f) => f.fieldName !== 'documentType'
      )
    ]
    onFilterChange(updatedFilters)
  }

  return (
    <div className="list">
      <BreadcrumHeader items={breadcrumbItems} />
      <Toolbar
        options={options}
        total={total}
        onButtonClick={() => setAddThresholdsModal(true)}
        buttonName="Add Thresholds"
        onDropdownSelect={handleDropdown}
        dropdownPlaceholder="Select Document Type"
        dropdownData={dropdownOptions}
      />
      <div className="list__main-container">
        <Table
          data={ThresholdsData?.content ?? []}
          loading={isLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={10}
          onPageChange={onPageChange}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                {key === 'isActive' ? (
                  <StatusCell
                    dataKey={key}
                    posDataLabel="Active"
                    negDataLabel="Inactive"
                  />
                ) : key === 'minConfidenceScore' ? (
                  <ConfidenceScoreCell dataKey={key} />
                ) : (
                  <Cell dataKey={key} tooltip />
                )}
              </Column>
            )
          })}

          <Column flexGrow={1} align="center">
            <HeaderCell>CreatedAt</HeaderCell>
            <DateTimeCell dataKey="createdAt" format="dd/MMM/yy, h:mm a" />
          </Column>

          <Column align="center" key="action" sortable>
            <HeaderCell>Action</HeaderCell>

            <ActionCell
              style={{ paddingLeft: '22%' }}
              tooltip
              dataKey="action"
              onAction={handleAction}
              actionOptions={['Edit']}
            />
          </Column>
        </Table>
      </div>
      <CreateThresholds
        open={addThresholdsModal}
        onClose={handleClose}
        isEditMode={isEditMode}
        thresholdsData={selectRowThresholds}
      />
    </div>
  )
}
export default ThresholdsList
